module.exports = __webpack_public_path__ + "static/media/mac.42b472a4.png";